import constants from "../../mixin/constants";

export default {
	dashboard: {
		role: [constants.ADMINISTRATOR, constants.SUPERVISOR, constants.OPERATOR],
		icon: "dashboard",
		text: "Dashboard",
		route: "hyperion.dashboard",
		children: null,
		shortKey: ["q", "1"]
	},
	monitoring: {
		role: [constants.SUPERVISOR],
		icon: "sync",
		text: "Monitoring",
		route: null,
		shortKey: null,
		children: {
			transaction: {
				role: [constants.SUPERVISOR],
				icon: null,
				text: "Live Transaction",
				route: "hyperion.monitoring.transaction",
				shortKey: ["q", "2"],
				children: null
			},
			transaction_banking_sale: {
				role: [constants.SUPERVISOR],
				icon: null,
				text: "Live Transaction Sale",
				route: "hyperion.monitoring.transaction.banking.sale",
				shortKey: ["q", "2"],
				children: null
			}
			// queue: {
			// 	icon: null,
			// 	text: 'Queue',
			// 	route: 'hyperion.monitoring.queue',
			// 	shortKey: ['q', '2']
			// }
		}
	},
	transactions: {
		role: [constants.SUPERVISOR, constants.OPERATOR],
		icon: "barcode",
		text: "Transactions",
		route: null,
		children: {
			live: {
				role: [constants.SUPERVISOR, constants.OPERATOR],
				icon: "monitor",
				text: "Transaction",
				route: "hyperion.transaction",
				shortKey: ["q", "2"],
				children: null
			},
			reconciled: {
				role: [constants.SUPERVISOR],
				icon: null,
				text: "Reconciliation",
				route: "hyperion.transaction.reconciled",
				shortKey: ["q", "2"],
				children: null
			},
			reconciled_summary: {
				role: [constants.SUPERVISOR],
				icon: null,
				text: "Summary",
				route: "hyperion.transaction.summary",
				shortKey: ["q", "3"],
				children: null
			}
			// transaction_disbursement: {
			// 	icon: null,
			// 	text: 'Disbursement',
			// 	route: 'hyperion.transaction.disbursement',
			// 	shortKey: ['q', '4'],
			// 	children: null
			// },
		}
	},
	// services: {
	// 	icon: 'customer-service',
	// 	text: 'Customer Service',
	// 	route: 'hyperion.customer-service',
	// 	children: {
	// 		feedback: {
	// 			icon: null,
	// 			text: 'Feedback',
	// 			route: 'hyperion.customer-service.feedback',
	// 			shortKey: ['q', '5']
	// 		}
	// 	}
	// },
	finances: {
		role: [constants.SUPERVISOR, constants.OPERATOR],
		icon: "dollar",
		text: "Financial Service",
		route: "hyperion.finances",
		shortKey: null,
		children: {
			/**
			deposit: {
				icon: null,
				text: 'Deposit Request',
				route: 'hyperion.finances.deposit',
				shortKey: ['q', '6'],
				children: null
			},
			bank: {
				icon: null,
				text: 'Bank',
				route: 'hyperion.finances.bank',
				shortKey: ['q', '7'],
				children: null
			},
			sponsors: {
				icon: null,
				text: 'Sponsors',
				route: null,
				shortKey: null,
				children: {
					sponsor: {
						icon: null,
						text: 'Sponsor Name',
						route: 'hyperion.finances.sponsor',
						shortKey: ['q', '8'],
						children: null
					},
					sponsor_config: {
						icon: null,
						text: 'Sponsor Config',
						route: 'hyperion.finances.sponsor-config',
						shortKey: ['q', '9'],
						children: null
					}
				}
			},
			*/
			banking_transactions: {
				role: [constants.SUPERVISOR, constants.OPERATOR],
				icon: null,
				text: "Banking Transactions",
				route: "hyperion.finances.banking-transactions",
				shortKey: ["q", "10"],
				children: null
			},
			transactions_off_us: {
				role: [constants.SUPERVISOR, constants.OPERATOR],
				icon: null,
				text: "Transactions Acquiring",
				route: "hyperion.finances.banking-transactions-off-us",
				shortKey: ["q", "11"],
				children: null
			},
			qris_transactions: {
				role: [constants.SUPERVISOR, constants.OPERATOR],
				icon: null,
				text: "QRIS Transactions",
				route: "hyperion.finances.banking-transactions-qris",
				shortKey: ["q", "12"],
				children: null
			},
			lakupandai: {
				role: [constants.SUPERVISOR, constants.OPERATOR],
				icon: "cloud-download",
				text: "Laku Pandai",
				route: "hyperion.lakupandai.transactions.index",
				children: null,
				shortKey: ["q", "13"]
			}
		}
	},
	biller: {
		role: [constants.SUPER_ADMIN],
		icon: "deployment-unit",
		text: "Billers",
		route: "hyperion.biller",
		children: null,
		shortKey: ["q", "8"]
	},
	client: {
		role: [constants.SUPER_ADMIN],
		icon: "solution",
		text: "Clients",
		route: "hyperion.client",
		children: null,
		shortKey: ["q", "9"]
	},
	products: {
		role: [constants.ADMINISTRATOR],
		icon: "qrcode",
		text: "Products",
		route: null,
		shortKey: null,
		children: {
			group: {
				role: [constants.ADMINISTRATOR],
				icon: null,
				text: "Product Groups",
				route: "hyperion.product-group",
				shortKey: ["a", "2"],
				children: null
			},
			product: {
				role: [constants.ADMINISTRATOR],
				icon: null,
				text: "Products",
				route: "hyperion.product",
				shortKey: ["a", "1"],
				children: null
			}
		}
	},
	user: {
		role: [constants.ADMINISTRATOR],
		icon: "team",
		text: "Users",
		route: "hyperion.user",
		children: null,
		shortKey: ["a", "3"]
	},
	// audit: {
	// 	icon: 'audit',
	// 	text: 'Audit Log',
	// 	route: 'hyperion.audit',
	// 	children: null,
	// 	shortKey: ['a', '4']
	// },
	setting: {
		role: [constants.SUPER_ADMIN],
		icon: "setting",
		text: "Setting",
		route: "hyperion.setting",
		children: null,
		shortKey: ["a", "5"]
	},
	log: {
		role: [constants.SUPERVISOR],
		icon: "audit",
		text: "Log Scheduler",
		route: "hyperion.lakupandai.log-schedulers.index",
		children: null,
		shortKey: ["q", "14"]
	},
	limit: {
		role: [constants.SUPERVISOR],
		icon: "credit-card",
		text: "Limit Transaction Laku Pandai",
		route: "hyperion.lakupandai.limit-transactions.index",
		children: null,
		shortKey: ["q", "14"]
	},
	download: {
		role: [constants.SUPERVISOR, constants.OPERATOR],
		icon: "cloud-download",
		text: "Download Center",
		route: "hyperion.attachment.download.center",
		children: null,
		shortKey: ["a", "7"]
	}
};
